import styled from 'styled-components';
import { TwoWayTransition } from 'foundations-components/transitional/components/TwoWayTransition';
import { View } from 'foundations-components/transitional/components/View';

// A lot of this is copied from https://git.hubteam.com/HubSpot/ContentEditorUI/blob/master/ContentEditorUI/static/js/components/sidebar/edit/ApplyChangesButton.js
import { jsx as _jsx } from "react/jsx-runtime";
const APPLY_CHANGES_BUTTON_HEIGHT = '81px';
const TRANSITION_TIME = 300;
const StyledTransitionWrapper = styled.div.withConfig({
  displayName: "ApplyPresetFooter__StyledTransitionWrapper"
})(({
  isUniversalThemeEditing,
  transitionActive,
  open,
  theme
}) => {
  return {
    width: '100%',
    flexShrink: 0,
    flexGrow: 0,
    transitionProperty: transitionActive ? 'height' : 'none',
    transitionDuration: `${TRANSITION_TIME}ms`,
    height: open ? APPLY_CHANGES_BUTTON_HEIGHT : '0px',
    borderInlineStart: isUniversalThemeEditing ? undefined : `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`
  };
});
const TransitionWrapper = props => {
  return /*#__PURE__*/_jsx(StyledTransitionWrapper, Object.assign({
    "data-component-name": "ApplyChangesButton",
    "data-open-complete": props.open && !props.transitioning,
    "data-transition-wrapper": true
  }, props));
};
export const ApplyChangesFooter = ({
  children,
  isUniversalThemeEditing,
  onOpenComplete,
  onCloseStart,
  isOpen
}) => {
  const _TransitionWrapper = props => /*#__PURE__*/_jsx(TransitionWrapper, Object.assign({}, props, {
    isUniversalThemeEditing: isUniversalThemeEditing
  }));
  return /*#__PURE__*/_jsx(TwoWayTransition, {
    duration: TRANSITION_TIME,
    Wrapper: _TransitionWrapper,
    onOpenComplete: onOpenComplete,
    onCloseStart: onCloseStart,
    children: isOpen ? /*#__PURE__*/_jsx(View, {
      backgroundColor: "fill-surface-default",
      boxShadow: "300",
      blockSize: "100%",
      padding: "500",
      children: children
    }) : null
  });
};
export default ApplyChangesFooter;